export enum EventCycle {
  CYCLE_EVERY_DAY = 'CYCLE_EVERY_DAY',
  CYCLE_EVERY_WEEK = 'CYCLE_EVERY_WEEK',
  CYCLE_EVERY_SECOND_WEEK = 'CYCLE_EVERY_SECOND_WEEK',
  CYCLE_EVERY_MONTH = 'CYCLE_EVERY_MONTH',
  CYCLE_EVERY_THIRD_MONTH = 'CYCLE_EVERY_THIRD_MONTH',
  CYCLE_EVERY_YEAR = 'CYCLE_EVERY_YEAR',
}
